<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Container, Radio, Text } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Types
	import type { InputOutputOptions } from './input_output_types';

	export let typeValue: string, initialStateValue: string, initialStateOptions: InputOutputOptions;

	const setInitialState = async (_initial_state_value) => {
		initialStateValue = _initial_state_value;
	};
</script>

<Container type="base" class={$showNewLayout ? 'mb-l' : 'mb-s'} padding="xs">
	<Text class={`text-bold ${$showNewLayout ? 'mb-m' : 'mb-s'}`}>
		{formatSnakeCaseToTitle(
			$format('action_on_power_on_default_label', {
				default: 'Action power on default',
			}),
		)}
	</Text>
	{#each Object.entries(initialStateOptions) as option}
		<Radio
			size="m"
			bind:selected={initialStateValue}
			value={option[0]}
			class={$showNewLayout ? 'mb-s' : ''}
			disabled={option[1].type !== typeValue && option[1].type !== 'any'}
			on:click={() => setInitialState(option[0])}
			id="radio-gtjaiev"
			info={$showNewLayout ? option[1]?.description : undefined}
		>
			{$showNewLayout ? option[1]?.title : option[1]?.text}
		</Radio>
	{/each}
</Container>
